import React, { useState, useRef, useEffect } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import UserManagementScreen from "./user-management";
import RoleManagement from "./role-management";
import { Dropdown } from "primereact/dropdown";
import { OverlayPanel } from "primereact/overlaypanel";

export default function MainUserManagement() {
  const menuRef = useRef(null);
  const exportCSVRef = useRef(() => {});

  const [globalFilter, setGlobalFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [tempStatus, setTempStatus] = useState("");
  const [tempRole, setTempRole] = useState(null);
  const [roleFilter, setRoleFilter] = useState(null);
  const [roles, setRoles] = useState([]);
  const [rowselect, setRowselect] = useState(null);
  const [editable, setEditable] = useState();
  const [selectedData, setSelectedData] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  const toggleDialogMode = (editMode = false, rowData = null) => {
    setShowDialog(true);
    setIsEdit(editMode);
    setRowselect(rowData);
    setEditable(editMode);

    if (!editMode) {
      setSelectedData(null);
      setRowselect(null);
    }
  };

  const handleApplyFilter = () => {
    setStatusFilter(tempStatus);
    setRoleFilter(tempRole);

    if (menuRef.current) {
      menuRef.current.hide();
    }
  };

  const handleResetFilter = (e) => {
    setStatusFilter("");
    setRoleFilter(null);
    setTempStatus("");
    setTempRole(null);
  };

  const resetFilters = () => {
    setGlobalFilter("");
  };

  return (
    <>
      <div className="grid align-items-center mb-3 p-2 justify-content-between gap-3">
        <div>
          <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              className="mbl_view"
              placeholder="Search"
              value={globalFilter}
              onChange={(e) => setGlobalFilter(e.target.value)}
            />
          </span>
        </div>

        <div className="grid gap-3">
        
          {activeTab === 0 && (
            <Button
              className="custom-btn export-excel secondary-button"
              label="Export Excel"
              icon="pi pi-window-maximize"
              onClick={() => exportCSVRef.current()}
            />
          )}
          <Button
            label="Add New"
            icon="pi pi-plus"
            onClick={() => {
              toggleDialogMode(false, null);
            }}
            className="p-button"
          />
        </div>
      </div>

        <TabView
          activeIndex={activeTab}
          onTabChange={(e) => {
            setActiveTab(e.index);
            resetFilters();
          }}
        >
          <TabPanel header="Add User">
            <UserManagementScreen
              showDialog={showDialog}
              setShowDialog={setShowDialog}
              isEdit={isEdit}
              setIsEdit={setIsEdit}
              selectedData={selectedData}
              exportCSV={exportCSVRef}
              globalFilter={globalFilter}
              statusFilter={statusFilter}
              roleFilter={roleFilter}
              setRoles={setRoles}
              roles={roles}
            />
          </TabPanel>
          <TabPanel header="Add Role">
            <RoleManagement
              showDialog={showDialog}
              setShowDialog={setShowDialog}
              isEdit={isEdit}
              setIsEdit={setIsEdit}
              selectedData={selectedData}
              globalFilter={globalFilter}
            />
          </TabPanel>
        </TabView>
    </>
  );
}
